import { toast } from "react-toastify";

// Success Notification
export const notifySuccess = (message: string) => {
  toast.success(message || "Operation successful!", {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: "colored",
  });
};

// Error Notification
export const notifyError = (message: string) => {
  toast.error(message || "Something went wrong!", {
    position: "top-right",
    autoClose: 4000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    theme: "colored",
  });
};

// Info Notification
export const notifyInfo = (message: string) => {
  toast.info(message || "Info message", {
    position: "top-right",
    autoClose: 3000,
    theme: "light",
  });
};
